import React, { useRef, useEffect, useState } from 'react';
import { Link } from "react-router-dom"; 
import { NavDropdown, Table } from 'react-bootstrap';
import { useActionState } from 'react';
import useSWR, { preload } from 'swr';
import { localAxios } from '../api';



const ApprovedVisitorsList = ({ approvedVs }) => {

  function formatDate(date) {
    const formattedDate = new Date(date).toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
    });
    return formattedDate.replace(/\//g, '-');
  }


  console.log(`approvedVs is ${approvedVs}`)

  const styles = {
    backgroundColor: "hsl(0, 0%, 22%)",
    color: "gold",
    padding: "10px 20px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    width: "130px"
  }

  return (
    <div>
      <Table align='center' cellPadding={3}>
        <tbody>
            <tr>
              <td colSpan={2}><b>Visitor</b></td>
              <td>  </td>
              <td colSpan={2}><b>Approver</b></td>
              <td>  </td>
              <td><b>Date</b></td>
            </tr>
            {
              approvedVs ? (
                approvedVs.map((approvedVs, index) => (
                  <tr key={index}>
                    <td>
                      {approvedVs.visitor_first_name}
                    </td>
                    <td>
                      {approvedVs.visitor_last_name}
                    </td>
                    <td>  </td>
                    <td> 
                      {approvedVs.approver_first_name}
                    </td>
                    <td> 
                      {approvedVs.approver_last_name}
                    </td>
                    <td>  </td>
                    <td>
                      {formatDate(approvedVs.approve_datetime)} 
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>Loading previous approvals...</td>
                </tr>
              )
            }
        </tbody>
      </Table>
    </div>
  );
}

export default ApprovedVisitorsList;

